<template>
  <footer class="policyFooter">
    <ul>
      <li><NuxtLink to="/policy?tab=0" target="_blank">{{ t('common-terms-of-use') }}</NuxtLink></li>
      <li><NuxtLink to="/policy?tab=1" target="_blank">{{ t('common-legal-notice') }}</NuxtLink></li>
      <li><NuxtLink to="/policy?tab=2" target="_blank">{{ t('common-privacy-policy') }}</NuxtLink></li>
      <li><NuxtLink to="/policy?tab=3" target="_blank">{{ t('common-cookie-policy') }}</NuxtLink></li>
    </ul>
    <p>{{ copyright }} </p>
  </footer>
</template>

<script setup lang="ts">
const { t } = useI18n();

const copyright = computed(() => `ⓒ ${new Date().getUTCFullYear()} Codepresso, Inc`);
</script>